/**
 * @prettier
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IndexLink } from 'react-router';
import Sticky from 'react-stickynode';

import { PLP_MODULE_GROUP_TAGS } from 'cards/constants/Cards';
import SkinnyBanner from 'components/promotions/SkinnyBanner';

import SecondaryNavItem from './SecondaryNavItem';

/* css imports */
import './SecondaryNav.less';

// these strings allow promo banner when present in the URL
export const BANNER_WHITELIST_URLS = [
  '/wedding-planning/invitations',
  '/wedding-planning/paper',
  '/wedding-planning/save-the-date',
  '/wedding-planning/change-the-date',
  '/wedding-planning/enclosures',
  '/wedding-planning/menus',
  '/wedding-planning/programs',
  '/wedding-planning/place-cards',
  '/wedding-planning/thank-you-cards',
  '/wedding-planning/draper-james',
  '/wedding-planning/lovely-bride',
  '/wedding-planning/holiday-cards',
];

const SecondaryNav = ({
  navItems,
  altActive,
  editActive,
  altActiveGlobal,
  activeGuestPage,
  guestRequestCount,
  userContext,
  activeCardEvent,
  enableSticky,
}) => {
  const nav = [];
  navItems.forEach((navItem, idx) => {
    const navEl =
      navItem.navUrl === '/wedding-planning' ? (
        <li key={idx}>
          <IndexLink key={idx} onlyActiveOnIndex to={navItem.navUrl} activeClassName="active">
            {navItem.navText}
          </IndexLink>
        </li>
      ) : (
        <SecondaryNavItem
          key={idx}
          navItem={navItem}
          idx={idx}
          altActive={altActive}
          editActive={editActive}
          altActiveGlobal={altActiveGlobal}
          activeGuestPage={activeGuestPage}
          guestRequestCount={guestRequestCount}
          userContext={userContext}
          activeCardEvent={activeCardEvent}
        />
      );
    nav.push(navEl);
  });

  return (
    <div id="sub-nav" className="menu-container-v2 row">
      <Sticky className="minimal-top-bar clearfix" top={60} enabled={enableSticky}>
        <div className="website-nav">
          <div className="menu-section">
            <ul className="preauth-menu">{nav}</ul>
          </div>
        </div>
        <SkinnyBanner tag={PLP_MODULE_GROUP_TAGS[activeCardEvent]} />
      </Sticky>
    </div>
  );
};

SecondaryNav.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))])),
    ])
  ),
  altActive: PropTypes.bool,
  editActive: PropTypes.bool,
  altActiveGlobal: PropTypes.bool,
  activeGuestPage: PropTypes.bool,
  guestRequestCount: PropTypes.number,
  userContext: PropTypes.shape({}),
  activeCardEvent: PropTypes.string,
  enableSticky: PropTypes.bool,
};

SecondaryNav.defaultProps = {
  enableSticky: true,
};

const mapStateToProps = state => ({
  weddingAccount: state.wedding.account,
  altActiveGlobal: state.guestList.guests.altActiveGlobal,
  guestRequestCount: state.publicWebsite.guestRequestCount,
  userContext: state.user.userContext,
});

export default connect(mapStateToProps, null)(SecondaryNav);



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNav/SecondaryNav.jsx